import { Tag, Tags } from '@/components/Tags';
import {
  AdCategoryCountItemType,
  AdFilterType,
  AdType,
  SortKey,
} from '@/resource/ad';
import { LocationItemType } from '@/resource/location';
import { decodePathSegment } from '@/util/encodePath';
import styles from './Criteria.module.scss';
import { SaveSearchButton } from './SaveSearchButton';

type Props = {
  adType: AdType;
  filter: AdFilterType;
  sort: SortKey;
  categoryIds: number[];
  distance: number;
  postalCode: string;
  location?: LocationItemType;
  appliedCategories: AdCategoryCountItemType[];
  hasLocation: boolean;
  filterBy: (value: {
    sort: SortKey;
    categoryIds: number[];
    distance: number;
    postalCode: string;
    keyword: string;
  }) => void;
};

export function Criteria({
  adType,
  filter,
  hasLocation,
  location,
  postalCode,
  categoryIds,
  sort,
  filterBy,
  appliedCategories,
  distance,
}: Props) {
  return (
    <div className={styles.Criteria}>
      <Tags>
        {filter.keyword != null && (
          <Tag
            readerLabel="Verwijder filter op zoekterm"
            visibleLabel={decodePathSegment(filter.keyword)}
            onClick={() => {
              filterBy({
                sort: sort || 'recent',
                categoryIds,
                distance,
                postalCode,
                keyword: '',
              });
            }}
          />
        )}

        {filter.distance != null && hasLocation && (
          <Tag
            onClick={() =>
              filterBy({
                sort: sort || 'recent',
                categoryIds,
                distance: -1,
                postalCode: '',
                keyword: filter.keyword || '',
              })
            }
            readerLabel="Verwijder filter op afstand"
            visibleLabel={`Binnen ${filter.distance} km van ${postalCode}`}
          />
        )}

        {appliedCategories.map((category) => (
          <Tag
            key={category.id}
            onClick={() =>
              filterBy({
                sort: sort || 'recent',
                categoryIds: categoryIds.filter((id) => id !== category.id),
                distance,
                postalCode,
                keyword: filter.keyword || '',
              })
            }
            readerLabel={`Verwijder filter op ${category.name}`}
            visibleLabel={category.name}
          />
        ))}
      </Tags>

      <SaveSearchButton
        filter={filter}
        location={location}
        adType={adType}
        sort={sort}
      />
    </div>
  );
}
